import { SecurityRegistryRecord } from "@models/shares/security-registry-record";

export function findCorrespondingRecord(targetRecord: SecurityRegistryRecord | undefined | null, records: SecurityRegistryRecord[]): SecurityRegistryRecord | null {
  if (!targetRecord) return null;
  const correspondingRecord = records
    .find((recordWithHoldings) => {
      const holdersCorrespond = recordWithHoldings.holders.every((holder) => targetRecord.holders.find((holderToPrefill) => holderToPrefill.relationshipId == holder.relationshipId));
      if (!holdersCorrespond) return false;

      const recordToPrefillHoldings = targetRecord.holdings ?? [];
      const holdingCorrespond = recordToPrefillHoldings.length > 0
        && recordToPrefillHoldings[0].number > 0
        && recordWithHoldings.holdings.every((holding) => recordToPrefillHoldings.find((recordToPrefillHolding) => recordToPrefillHolding.securityHoldingId == holding.securityHoldingId));

      return holdingCorrespond;
    }) ?? null;

  if (correspondingRecord) return correspondingRecord;

  const recordWithCorrespondingHolders = records
    .find((recordWithHoldings) => {
      return targetRecord.holders.length == recordWithHoldings.holders.length
        && recordWithHoldings.holders.every((holder) => targetRecord.holders.find((holderToPrefill) => holderToPrefill.relationshipId == holder.relationshipId));
    }) ?? null;

  return recordWithCorrespondingHolders;
}
